var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorporateshape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 593,
    viewBox: "0 0 290 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.75 593.001V302.604H0C0.873 463.131 130.26 593.001 289.75 593.001Z",
    fill: "#5916AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.673 434.023V302.604H153.427C154.202 375.336 214.879 434.023 289.673 434.023Z",
    fill: "#FFC43D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 153.525V308.411H155.74C155.512 267.255 139.003 227.863 109.821 198.841C80.6394 169.819 41.1566 153.527 0 153.525Z",
    fill: "#5916AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0419922 231.448V308.448H77.87C77.6569 287.949 69.3625 268.363 54.7894 253.945C40.2163 239.526 20.5421 231.442 0.0419922 231.448Z",
    fill: "#FFC43D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.162 0H289.75V311.6H153.082V63.08C153.082 46.3501 159.728 30.3055 171.558 18.4757C183.388 6.64591 199.432 0 216.162 0Z",
    fill: "#5916AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateshape1);
export default __webpack_public_path__ + "static/media/corporateshape1.1afbe587a2091c68b23ac3b6ed2aa58f.svg";
export { ForwardRef as ReactComponent };